import { useEffect, useState } from "react";
import BoxSelectTimeslotInterval from "./boxEditTimeslotInterval"

const BoxEditTimeslotInterval = (props: any) => {
  let timeslotAvailabilityInput: any = props.timeslotAvailability ?? [];
  const [timeslotAvailability, setTimeslotAvailability] = useState(timeslotAvailabilityInput);

  useEffect(() => {
    setTimeslotAvailability(timeslotAvailabilityInput)
  }, [timeslotAvailabilityInput])

  const UpdateStartDate = (input: any, id: number) => {
    let array: any = Object.assign([], timeslotAvailability);
    array[id].startTime = input;
    setTimeslotAvailability(array)

  }
  const UpdateEndDate = (input: any, id: number) => {
    let array: any = Object.assign([], timeslotAvailability);
    array[id].endTime = input;
    setTimeslotAvailability(array)
  }
  return (
    <>
      {(timeslotAvailability.map((timeslot: any, index: number) => (
        <div key={index}>
          <BoxSelectTimeslotInterval
            id={index}
            handelClick={props.handelClick}
            value={timeslot}
            handleChangeStardDate={UpdateStartDate}
            handleChangeEndDate={UpdateEndDate}
            icon={((index === (timeslotAvailability.length - 1)) ? "add" : "delete")} />
        </div>
      )))}
    </>

  )
}

export default BoxEditTimeslotInterval 